const moment = require('moment');
import { IGoalDataPoint, maxDatapointAgeForDaysLeft } from 'motw_core/Entity/IGoalDataPoint';
import { IGoalWithDatapoints } from 'motw_core/Repositories/DatapointRepository';
import { IsDatapointRelevant } from 'motw_core/Goals/GoalDataPoints/IsDatapointRelevant';

export const CalculateDaysLeft = (goalData: IGoalWithDatapoints) => {
	if (!goalData.istracking || goalData.isarchived) {
		return 999;
	}

	const daysSinceStart = moment().diff(moment(goalData.startdate), 'days');

	const hasGoalStartedToday = daysSinceStart === 0;
	if (hasGoalStartedToday) {
		return maxDatapointAgeForDaysLeft;
	}

	const relevantDatapoints = goalData.datapoints.filter((dp) =>
		IsDatapointRelevant(dp, goalData.startdate)
	);

	const hasNoRelevantDatapoints = relevantDatapoints.length === 0;
	if (hasNoRelevantDatapoints) {
		return maxDatapointAgeForDaysLeft - daysSinceStart;
	}

	const timeValueOfDatapoints = GetDatapointsImpact(
		relevantDatapoints,
		goalData.weeklyrate,
		goalData.startdate
	);

	const roundedDaysDue = Number.parseFloat(timeValueOfDatapoints.toFixed(2));
	return roundedDaysDue;
};

function GetDatapointsImpact(
	relevantDatapoints: IGoalDataPoint[],
	currWeeklyRate: number,
	startDate: string
) {
	if (currWeeklyRate === 0) {
		return 0;
	}

	const daysSinceStart = moment().diff(moment(startDate), 'days');

	const doesGoalHaveInsufficientData =
		daysSinceStart < maxDatapointAgeForDaysLeft;

	// Increase the impact of the datapoints made so far if the goal isn't old enough
	const newGoalAdjustmentMultiple = doesGoalHaveInsufficientData
		? maxDatapointAgeForDaysLeft / daysSinceStart
		: 1;

	const sumOfDataPoints = relevantDatapoints.length
		? relevantDatapoints.map((dp) => dp.value).reduce((a, b) => a + b)
		: 0;

	const datapointsImpact =
		sumOfDataPoints * newGoalAdjustmentMultiple * (7 / currWeeklyRate);

	return datapointsImpact;
}


